import { __exports as i } from "./contact-channels242.js";
var r;
function R() {
  if (r) return i;
  r = 1, Object.defineProperty(i, "__esModule", { value: !0 }), i.camelCase = void 0;
  var u = /^--[a-zA-Z0-9_-]+$/, c = /-([a-z])/g, n = /^[^-]+$/, s = /^-(webkit|moz|ms|o|khtml)-/, E = /^-(ms)-/, _ = function(e) {
    return !e || n.test(e) || u.test(e);
  }, l = function(e, a) {
    return a.toUpperCase();
  }, t = function(e, a) {
    return "".concat(a, "-");
  }, m = function(e, a) {
    return a === void 0 && (a = {}), _(e) ? e : (e = e.toLowerCase(), a.reactCompat ? e = e.replace(E, t) : e = e.replace(s, t), e.replace(c, l));
  };
  return i.camelCase = m, i;
}
export {
  R as __require
};
//# sourceMappingURL=contact-channels237.js.map
